<template>
  <div class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-4 mb-8">
    <v-card class="mx-auto py-xl-4 py-lg-4 py-md-4 py-sm-4" max-width="448" :outlined="$vuetify.breakpoint.smAndUp" :flat="$vuetify.breakpoint.xsOnly">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">Registrarse</v-list-item-title>
          <v-list-item-subtitle>Crea una cuenta de de club lentes</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-form ref="form">
        <v-card-text class="px-xl-8 px-lg-8 px-md-8 px-sm-8 px-5">
          <v-row justify="center" no-gutters>
            <v-col cols="11">
              <v-text-field
                v-model="user.first_name"
                label="Nombre"
                :rules="[isRequired, minimum(3)]"
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="11">
              <v-text-field
                v-model="user.last_name"
                label="Apellidos"
                :rules="[isRequired, minimum(5)]"
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="11">
              <v-text-field
                v-model="user.email"
                label="Correo electrónico"
                :rules="[isRequired, isEmail]"
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="11">
              <v-text-field
                v-model="user.password"
                label="Contraseña"
                :rules="[isRequired, minimum(6)]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                autocomplete="new-password"
                filled
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-xl-8 px-lg-8 px-md-8 px-sm-8 px-5 pb-6 mt-n4">
          <v-row justify="center" no-gutters>
            <v-col cols="11" class="mb-2">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" dark @click="register">
                Crear cuenta
              </v-btn>
            </v-col>
            <v-col cols="11">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" outlined dark @click="goToRouteByName('Login')">
                Ya tengo una cuenta
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import { isRequired, isEmail, minimum } from '@/shared/validations'
import { getErrorMessage } from '@/shared/errors'
import { COMPLETE_REGISTRATION_EVENT, saveTrackingEvent } from '@/shared/tracker'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      showPassword: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading'])
  },
  methods: {
    isRequired,
    isEmail,
    minimum,
    ...mapActions('auth', ['signUp']),
    async register () {
      if (!this.$refs.form.validate()) {
        return
      }

      await this.signUp(this.user)
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('register', this.error) })
        return
      }

      saveTrackingEvent({ eventName: COMPLETE_REGISTRATION_EVENT, data: { user: this.user } })
      this.$emit('notificationPopup', { icon: 'check_circle', color: 'success', message: 'Bienvenido ' + this.user.first_name + ', ya puedes iniciar sesión' })
      this.goToRouteByName('Login')
    }
  }
}
</script>
<style scoped>
</style>
